export default {
  isType (identifier) {
    return identifier === 'string'
  }
}
